import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "recently-viewed-products";
const MAX_ITEMS = 6;

export function useRecentlyViewed() {
  const [ids, setIds] = useState<number[]>(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }, [ids]);

  const addViewed = useCallback((productId: number) => {
    setIds((prev) => {
      const filtered = prev.filter((id) => id !== productId);
      return [productId, ...filtered].slice(0, MAX_ITEMS);
    });
  }, []);

  return { recentIds: ids, addViewed };
}
